import ApiService from 'src/shared/utils/base-api/api-service';
import {ResponseDto} from 'src/shared/common-dtos/response-dto';
import {ParamsDto} from 'src/shared/common-dtos/params-dto';
import {DataListDto} from 'src/shared/common-dtos/data-list-dto';
import {PatientDetailsDto} from './dto/patient-details-dto';
import {TreatmentDetailsDto} from './dto/treatment-details-dto';
import {CaseDetailsDto} from './dto/case/case-details-dto';
import {FollowUpDto} from './dto/follow-up-dto';
import {SdcAccountStatusDto} from './dto/sdc-account-status-dto';

class PatientService extends ApiService {
  constructor() {
    super({
      baseURL: '/Patient',
    });
  }

  public getAllPatients(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<PatientDetailsDto>>> {
    return this.get('/GetAllPatients', {
      params: input,
    });
  }

  public getAllTreatments(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<TreatmentDetailsDto>>> {
    return this.get('/GetAllTreatments', {
      params: input,
    });
  }

  public getActionNeededTreatments(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<TreatmentDetailsDto>>> {
    return this.get('/GetActionNeededTreatments', {
      params: input,
    });
  }

  public getArchivedTreatments(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<TreatmentDetailsDto>>> {
    return this.get('/GetArchivedTreatments', {
      params: input,
    });
  }

  public getTreatmentById(
    treatmentId: string,
    additionalTreatmentId?: string,
  ): Promise<ResponseDto<TreatmentDetailsDto>> {
    return this.get('/GetTreatmentById', {
      params: {
        TreatmentId: treatmentId,
        AdditionalTreatmentId: additionalTreatmentId,
      },
    });
  }
  public getOnGoingTreatments(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<TreatmentDetailsDto>>> {
    return this.get('/GetOnGoingTreatments', {
      params: input,
    });
  }

  public getAllCases(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<CaseDetailsDto>>> {
    return this.get('/GetAllCases', {
      params: input,
    });
  }

  public getActionNeededCases(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<CaseDetailsDto>>> {
    return this.get('/GetActionNeededCases', {
      params: input,
    });
  }

  public getArchivedCases(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<CaseDetailsDto>>> {
    return this.get('/GetArchivedCases', {
      params: input,
    });
  }

  public getCaseById(
    caseId: string,
    additionalCaseId?: string,
  ): Promise<ResponseDto<CaseDetailsDto>> {
    return this.get('/GetCaseById', {
      params: {
        CaseId: caseId,
        AdditionalCaseId: additionalCaseId,
      },
    });
  }
  public getOnGoingCases(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<CaseDetailsDto>>> {
    return this.get('/GetOnGoingCases', {
      params: input,
    });
  }
  public deleteTreatment(
    treatmentId?: string,
    additionalId?: string,
  ): Promise<ResponseDto<TreatmentDetailsDto>> {
    return this.delete('/DeleteTreatment', {
      params: {patientId: treatmentId, treatmentId, additionalId},
    });
  }
  public deleteCase(
    caseId?: string,
    additionalId?: string,
  ): Promise<ResponseDto<TreatmentDetailsDto>> {
    return this.delete('/DeleteCase', {
      params: {patientId: caseId, caseId, additionalId},
    });
  }

  public getPatientFollowUps(
    patientId: string,
  ): Promise<ResponseDto<FollowUpDto[]>> {
    return this.get('/GetPatientFollowUps', {
      params: {PatientId: patientId},
    });
  }

  public getSdcAccountStatus(
    patientId: string,
  ): Promise<ResponseDto<SdcAccountStatusDto>> {
    return this.get('/GetSdcAccountStatus', {params: {PatientId: patientId}});
  }

  public recreateSdcPatient(
    patientId: string,
  ): Promise<ResponseDto<SdcAccountStatusDto>> {
    return this.post('/RecreateSdcPatient', {patientId});
  }
}

export const patientService = new PatientService();
